export default {
  getAuth: state => state.auth,
  getAuthUser: state => state.auth && state.auth.user,
  getAuthToken: state => state.auth && state.auth.token,
  getLastSignupStep: state => state.lastSignupStep,
  getLandingUrl: state => state.landingURL,
  getNewCampaignId: state => state.newCampaignId,
  getCompany: state => state.company,
  campaign: state => state.campaign,
  getCompanyBalances: state => state.companyBalances,
  isWhiteLabel: state => state.isWhiteLabel,
  isUserClient: state => state.auth &&
    state.auth.user &&
    state.auth.user.role &&
    state.auth.user.role.role_type === 'client',
  isUserAdmin: state => state.auth &&
    state.auth.user &&
    state.auth.user.role &&
    state.auth.user.role.role_type === 'administrator'
};



// WEBPACK FOOTER //
// ./src/store/getters.js